import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { JustiFiService } from 'src/app/services/justifi-service/justifi.service';
import { InvoiceStatusEnum, PaymentProcessorOnboardingStatusTypes } from 'src/app/shared/enums/invoice/invoice.enum';
import { PaymentFee, PaymentStatusTypes, PaymentType } from 'src/app/shared/enums/payment/payment.enum';
import { MakePayLoad, PaymentFormDTO } from 'src/app/shared/interfaces/payment/payment.interface';
import { settingsProp } from 'src/app/shared/interfaces/settings/setting.interface';
import { JustifiClientId } from 'src/app/shared/utils/globals';
import { NumberUtil, decimal2 } from 'src/app/shared/utils/util-function';
import { PortalUrlContentDetailsModal } from './../../shared/modals/portal-url-content-details.modal';
import { PortalUrlService } from 'src/app/services/portal-url.service/portal-url.service';
import { InvoiceService } from 'src/app/services/invoice-service/invoice.service';
import { EstimatesService } from 'src/app/services/estimate-service/estimate.service';
import { ApiError } from 'src/app/services/api-error';
import { LogRocketService } from 'src/app/services/logrocket-service/logrocket.service';
import { describePaymentFailure, describeRejectedDetails, PaymentFailure } from './payment-failure';


@Component({
    selector: 'projul-justifi-payment',
    templateUrl: './justifi-payment.component.html',
    styleUrls: ['./justifi-payment.component.scss']
})
export class JustiFiPaymentComponent implements OnInit {

    @Input() invoice: PortalUrlContentDetailsModal; // input to get invoice data from portal component
    @Input() settings = settingsProp // setting from portal component
    creditCard: any; // instance create for justifi
    bankAccount: any;
    paymentFee = PaymentFee //payment fee who will pay
    showPayInput: boolean = false; // partial payment input show
    paymentfailed: boolean = false; // payment is failed show notifications
    paymentsuccessful: boolean = false; // payment is failed show notifications
    paymentprocessing: boolean = false; // submitting payment with loader notifications
    isACHPayment: boolean = false // switch ach to credit card fields and vice versa
    payAlias: number; // how much user want to pay the amount
    remainingValue: number; // after selecting amount remaing amount
    withOutFeeTotal: number // total invoice without paying fee
    PaymentTotal: number // total amout with fee
    AchPaymentTotal: number // total amout with fee
    cardProcessingFee: number = 0 // card processing fees if customer has to pay the fees
    achProcessingFee: number = 0; // ach processing fees if customer has to pay the fee
    form: FormGroup // form grounp initilizer
    achForm: FormGroup // form grounp initilizer
    message: string
    allowedToPay: boolean = true;
    processingFee: any;
    isInvoiceChanged = false;

    constructor(private justiFiService: JustiFiService,
        private portalUrlService: PortalUrlService,
        private invoiceService: InvoiceService,
        private estimateService: EstimatesService,
        private logRocketService: LogRocketService) {
        this.form = this.justiFiService.generateCreditCardForm() // call back from service
        this.achForm = this.justiFiService.generateACHForm() // call back from service
    }

    ngOnInit(): void {

        this.creditCard = document.querySelector('justifi-card-form') as any;
        this.bankAccount = document.querySelector('justifi-bank-account-form') as any;

        this.processingFee = settingsProp.PaymentProcessingFee;
        if (this.settings.PaymentProcessingFee) {
            this.processingFee = this.settings?.PaymentProcessingFee;
        }

        if (this.invoice.Item.CreditCardFee === PaymentFee.Customer)
            this.calc_height('514px', '0px');
        else
            this.calc_height('470px', '0px');
        if (this.invoice.Item?.Payments) {
            var paidAmt = this.invoice.Item?.Payments?.length ? _.sum(this.invoice.Item?.Payments.map((x: { Status: any; Amount: any; }) => (x.Status == PaymentStatusTypes.Pending ? NumberUtil.ToNumber(x.Amount) : 0))) : 0;
            if (paidAmt > 0)
                this.invoice.Item.RemainingBalance -= paidAmt;
        }
        this.withOutFeeTotal = this.invoice.Item.RemainingBalance // save remiang amount globally
        this.handleAmount(this.invoice.Item.RemainingBalance) // handle fees
        // credit card and ach section handle
        if (this.invoice.Item.AcceptACH && !this.invoice.Item.AcceptCreditCard) { // ach and credit card switcher holder using settings or invoice toggle
            // this.isACHPayment = true
            this.ACHPayment();
        }
        this.creditCard.validationMode = 'all'
        this.bankAccount.validationMode = 'all'
        this.allowedToPay = this.invoice.Item.Status == InvoiceStatusEnum.PendingSend || this.invoice.Item.Status == InvoiceStatusEnum.PendingPayment || this.invoice.Item.Status == InvoiceStatusEnum.Partial || this.invoice.Item.Status == InvoiceStatusEnum.Overdue;
    }

    get f() {
        return this.form?.controls;
    }
    get fAch() {
        return this.achForm?.controls;
    }

    handleAmount(amount: number) {

        this.withOutFeeTotal = amount;
        this.invoice.Item.RemainingValue = this.invoice.Item.RemainingBalance;

        if (!this.isACHPayment) {
            this.PaymentTotal = amount;
            this.cardProcessingFee = 0;
            if (this.invoice.Item.AcceptCreditCard) {
                this.cardProcessingFee = this.justiFiService.getFees(amount, this.processingFee).cCFee;
                if (this.invoice.Item.CreditCardFee === PaymentFee.Customer) {
                    this.PaymentTotal = amount + this.cardProcessingFee;
                }
            }
            this.invoice.Item.RemainingValue = this.PaymentTotal;
        }
        else {
            this.AchPaymentTotal = amount;
            this.achProcessingFee = 0;
            if (this.invoice.Item.AcceptACH) {
                this.achProcessingFee = this.justiFiService.getFees(amount, this.processingFee, true).aCHFee;
                if (this.invoice.Item.AchFee === PaymentFee.Customer) {
                    this.AchPaymentTotal = amount + this.achProcessingFee;
                }
            }
            this.invoice.Item.RemainingValue = this.AchPaymentTotal;
        }

        this.remainingValue = this.invoice.Item.RemainingValue;
    }

    partialPayment(type: string) { // partial payment

        this.payAlias = 0
        this.showPayInput = !this.showPayInput
        if (type === 'full') {
            this.handleAmount(this.invoice.Item.RemainingBalance)
        }
        if (type === 'partial') {
            this.getChnagedValue(null);
        }
    }

    getChnagedValue(payAliasInput: any) { // changes value payment

        if (this.payAlias > this.invoice.Item.RemainingValue)
            this.payAlias = this.invoice.Item.RemainingValue;

        if (this.isACHPayment) {
            if (payAliasInput && this.payAlias > 0 && this.payAlias < 2) {
                this.payAlias = 2;
                setTimeout(() => {
                    payAliasInput.value = this.payAlias;
                    payAliasInput.input.nativeElement.focus();
                });
            }
            this.achProcessingFee = this.justiFiService.getFees(this.payAlias, this.processingFee, true, this.showPayInput).aCHFee || 0;
        }
        else {
            if (payAliasInput && this.payAlias > 0 && this.payAlias < 1) {
                this.payAlias = 1;
                setTimeout(() => {
                    payAliasInput.value = this.payAlias;
                    payAliasInput.input.nativeElement.focus();
                });
            }
            this.cardProcessingFee = this.justiFiService.getFees(this.payAlias, this.processingFee, false, this.showPayInput).cCFee || 0;
        }

        this.withOutFeeTotal = this.payAlias //- (decimal2(this.cardProcessingFee))

        if (this.isACHPayment) {
            this.AchPaymentTotal = NumberUtil.ToNumber(this.payAlias);
            this.withOutFeeTotal = this.AchPaymentTotal;
            if (this.invoice.Item.AchFee === PaymentFee.Customer) {
                this.withOutFeeTotal = this.AchPaymentTotal - this.achProcessingFee;
            }
        }
        else {
            this.PaymentTotal = NumberUtil.ToNumber(this.payAlias);
            this.withOutFeeTotal = this.PaymentTotal;
            if (this.invoice.Item.CreditCardFee === PaymentFee.Customer)
                this.withOutFeeTotal = this.PaymentTotal - this.cardProcessingFee;
        }

        this.remainingValue = this.invoice.Item.RemainingValue - this.payAlias;
    }

    async isInvoicechanged(): Promise<boolean> {
        let latestInvoiceRecord = (await this.portalUrlService.getInvoicePayments(this.invoice.UrlId, this.invoice.Item?.Id))?.Response as any;
        if (latestInvoiceRecord && latestInvoiceRecord.length > 0) {

            let payments = (latestInvoiceRecord || []).filter((x: any) => x.Status !== PaymentStatusTypes.Failed && x.Status !== PaymentStatusTypes.Canceled && x.Status !== PaymentStatusTypes.RefundFailed);
            return payments.length != 0 && payments.some((f: any) => !(this.invoice.Item?.Payments || [])?.some((h: any) => h.Id == f.Id));
        }

        return false;
    }

    payNowAmount() {
        if (!this.settings.ViewJustiFiIntegrationForDemo && !this.paymentprocessing) {
            Object.keys(this.form.controls).forEach((key) => {
                this.form.controls[key].markAsDirty();
            });
            if (this.form.invalid) {
                return
            } else {
                this.paymentProcessing(true, false, false);

                let JustiFiOnboardingSettings = {} as any
                if (this.settings.JustiFiOnboardingSettings && this.settings.JustiFiOnboardingSettings.Status != PaymentProcessorOnboardingStatusTypes.OnboardingNotStarted) {
                    let data = this.settings.JustiFiOnboardingSettings as any
                    JustiFiOnboardingSettings = data
                }

                let forms = this.form.value as PaymentFormDTO;

                const paymentMethodData = {
                    name: forms.Name,
                    address_postal_code: forms.PostalCode,
                };

                this.creditCard?.validate().then(async (data: any) => {
                    if (data?.isValid) {
                        this.paymentProcessing(true, false, false);
                        this.isInvoiceChanged = await this.isInvoicechanged()
                        if (this.isInvoiceChanged) {
                            this.paymentProcessing(false, false, true);
                            const companyName = this.invoice?.Item?.CompanyName || 'our support team';
                            this.message = `The payment could not be processed because the balance due in our records does not match the balance displayed. Please refresh the page and try again. If the issue persists, please contact ${companyName}.`;
                            return;
                        }
                        this.creditCard?.tokenize(JustifiClientId, paymentMethodData, JustiFiOnboardingSettings.Account.id).then(async (response: any) => {
                            if ((response?.error?.message || '') != '') {
                                this.reportPaymentFailure(describeRejectedDetails(response.error.message), 'card', response.error.message);
                            }
                            else {
                                let payLoad = {} as MakePayLoad
                                payLoad.JustiFiOnboardingSettings = JustiFiOnboardingSettings;
                                payLoad.PaymentTotal = this.PaymentTotal;
                                payLoad.cardProcessingFee = this.cardProcessingFee;
                                payLoad.forms = forms
                                payLoad.invoice = this.invoice;
                                payLoad.responseAPI = response;
                                payLoad.Type = PaymentType.CreditCard
                                payLoad.remainingBlc = this.showPayInput ? this.remainingValue : 0;
                                payLoad.capture_strategy = 'automatic';
                                await this.checkout(payLoad);
                            }
                        }).catch((error: unknown) => this.showPaymentFailure(error, 'card'));
                    }
                    else
                        this.showInvalidDetails();
                }).catch((error: unknown) => this.showPaymentFailure(error, 'card'))
            }
        }
    }

    payNowByJustiFiBankAccount() {
        if (!this.settings.ViewJustiFiIntegrationForDemo && !this.paymentprocessing) {
            Object.keys(this.achForm.controls).forEach((key) => {
                this.achForm.controls[key].markAsDirty();
            });
            if (this.achForm.invalid) {
                return;
            }
            else {
                this.paymentProcessing(true, false, false);

                let JustiFiOnboardingSettings = {} as any
                if (this.settings.JustiFiOnboardingSettings && this.settings.JustiFiOnboardingSettings.Status != PaymentProcessorOnboardingStatusTypes.OnboardingNotStarted) {
                    let data = this.settings.JustiFiOnboardingSettings as any
                    JustiFiOnboardingSettings = data
                }

                let forms = this.achForm.value as PaymentFormDTO;

                const paymentMethodData = {
                    name: forms.Name,
                    account_type: JustiFiOnboardingSettings.Bank.data.account_type, // checking or savings
                    account_owner_type: 'individual' // individual or company
                };

                this.bankAccount?.validate().then(async (data: any) => {
                    if (data?.isValid) {
                        this.isInvoiceChanged = await this.isInvoicechanged()
                        if (this.isInvoiceChanged) {
                            this.paymentProcessing(false, false, true);
                            const companyName = this.invoice?.Item?.CompanyName || 'our support team';
                            this.message = `The payment could not be processed because the balance due in our records does not match the balance displayed. Please refresh the page and try again. If the issue persists, please contact ${companyName}.`;
                            return;
                        }
                        this.bankAccount?.tokenize(JustifiClientId, paymentMethodData, JustiFiOnboardingSettings.Account.id).then(async (response: any) => {
                            if ((response?.error?.message || '') != '') {
                                this.reportPaymentFailure(describeRejectedDetails(response.error.message), 'ach', response.error.message);
                            }
                            else {
                                let payLoad = {} as MakePayLoad
                                payLoad.JustiFiOnboardingSettings = JustiFiOnboardingSettings;
                                payLoad.PaymentTotal = this.AchPaymentTotal;
                                payLoad.achProcessingFee = this.achProcessingFee;
                                payLoad.forms = forms
                                payLoad.invoice = this.invoice;
                                payLoad.responseAPI = response;
                                payLoad.Type = PaymentType.ACH;
                                payLoad.remainingBlc = this.showPayInput ? this.remainingValue : 0;
                                payLoad.capture_strategy = 'automatic';
                                await this.checkout(payLoad);
                            }
                        }).catch((error: unknown) => this.showPaymentFailure(error, 'ach'));
                    }
                    else
                        this.showInvalidDetails();
                }).catch((error: unknown) => this.showPaymentFailure(error, 'ach'))
            }
        }
    }

    private async checkout(payLoad: MakePayLoad): Promise<void> {
        const res = await this.justiFiService.payCheckOut(this.justiFiService.payLoad(payLoad));
        if (!res.IsSuccessful) {
            throw new ApiError('Checkout answered without success.', res.StatusCode, typeof res.Response === 'string' ? res.Response : null);
        }
        this.paymentProcessing(false, true, false);
    }

    private showPaymentFailure(error: unknown, method: 'card' | 'ach'): void {
        this.reportPaymentFailure(describePaymentFailure(error), method, error instanceof Error ? error.message : String(error));
    }

    private reportPaymentFailure(failure: PaymentFailure, method: 'card' | 'ach', detail: string): void {
        this.paymentProcessing(false, false, true);
        this.message = failure.message;
        this.logRocketService.captureMessage('Invoice payment failed.', {
            tags: { feature: 'invoice-payment', outcome: failure.outcome, method },
            extra: { status: failure.status, invoiceId: this.invoice?.Item?.Id, error: detail }
        });
    }

    // The payment form already marks the invalid fields, so this is not reported as a failed payment.
    private showInvalidDetails(): void {
        this.paymentProcessing(false, false, true);
        this.message = describeRejectedDetails().message;
    }

    containerHeight: string
    ACHPayment() {
        if (this.invoice.Item.CreditCardFee === PaymentFee.Customer)
            this.calc_height('402px', '514px');
        else
            this.calc_height('357px', '470px');

        this.isACHPayment = true;

        this.handleAmount(this.invoice.Item.RemainingBalance);

        if (this.showPayInput) {
            if (this.payAlias > this.invoice.Item.RemainingValue)
                this.payAlias = this.invoice.Item.RemainingValue;

            if (this.payAlias > 0 && this.payAlias < 2) {
                this.payAlias = 2;
            }

            this.AchPaymentTotal = (this.payAlias === undefined || this.payAlias === 0) && !this.showPayInput ? this.invoice.Item.RemainingBalance : this.payAlias // this.PaymentTotal;
            this.withOutFeeTotal = this.AchPaymentTotal;
            this.achProcessingFee = this.justiFiService.getFees(this.AchPaymentTotal, this.processingFee, true, this.showPayInput).aCHFee
            if (this.invoice.Item.AchFee === PaymentFee.Customer) {
                this.AchPaymentTotal = NumberUtil.ToNumber(this.AchPaymentTotal);
                this.withOutFeeTotal = this.AchPaymentTotal - this.achProcessingFee;
            }

            this.remainingValue = this.invoice.Item.RemainingValue - this.AchPaymentTotal;
        }
    }

    ccPayment() {
        if (this.invoice.Item.CreditCardFee === PaymentFee.Customer)
            this.calc_height('514px', '402px');
        else
            this.calc_height('470px', '357px');
        this.isACHPayment = false

        this.handleAmount(this.invoice.Item.RemainingBalance);

        if (this.showPayInput) {
            if (this.payAlias > this.invoice.Item.RemainingValue)
                this.payAlias = this.invoice.Item.RemainingValue;

            if (this.payAlias > 0 && this.payAlias < 1) {
                this.payAlias = 1;
            }

            this.PaymentTotal = (this.payAlias === undefined || this.payAlias === 0) && !this.showPayInput ? this.invoice.Item.RemainingBalance : this.payAlias  // this.AchPaymentTotal;
            this.withOutFeeTotal = this.PaymentTotal;
            this.cardProcessingFee = this.justiFiService.getFees(this.PaymentTotal, this.processingFee, false, this.showPayInput).cCFee
            if (this.invoice.Item.CreditCardFee === PaymentFee.Customer) {
                this.PaymentTotal = NumberUtil.ToNumber(this.PaymentTotal);
                this.withOutFeeTotal = this.PaymentTotal - this.cardProcessingFee;
            }

            this.remainingValue = this.invoice.Item.RemainingValue - this.PaymentTotal;
        }
    }

    paymentProcessing(paymentprocessing: boolean, paymentsuccessful: boolean, paymentfailed: boolean) {
        this.paymentprocessing = paymentprocessing;
        this.paymentsuccessful = paymentsuccessful;
        this.paymentfailed = paymentfailed;

        if (this.paymentsuccessful) {
            setTimeout(() => {
                this.paymentSubmitted();
            }, 2000);
        }
    }

    previous() {
        this.paymentProcessing(false, false, false);
    }

    refresh() {
        window.location.reload();
    }

    paymentSubmitted() {
        window.location.reload();
    }

    calc_height(getheight: string, intialHeight: string) {
        this.containerHeight = intialHeight
        setTimeout(() => {
            this.containerHeight = getheight
        }, 100)
        setTimeout(() => {
            this.containerHeight = 'auto'
        }, 1000);
    }

    onPopoverShown(getCurrent: any) {
        setTimeout(() => {
            getCurrent.classList.add('animatePop');
        }, 100);
    }

    onPopoverHidden(getCurrent: any) {
        getCurrent.classList.remove('animatePop');
    }
}
